export default __webpack_public_path__ + "static/media/diamond-cut-3@2x.6017f2ab.jpg";